import VideoStyle from './VideoStyle'

export default VideoStyle
